import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/HomePage/Hero";
import AboutSection from "./components/HomePage/AboutSection";
import Partners from "./components/HomePage/Partners";
import Timeline from "./components/HomePage/Timeline";
import Committee from "./components/Committee";
import Footer from "./components/Footer";
import AboutPage from "./components/AboutPage";
import CommitteeMemberDetails from "./components/CommitteeMemberDetails";
import CallForPapers from "./components/CallForPapers";
import Registration from "./components/Registration";
import ContactUs from "./components/ContactUs";
import "./App.css";

function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const [selectedCommitteeCategory, setSelectedCommitteeCategory] = useState(null);
  const [showScroll, setShowScroll] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const handleNavigation = (page) => {
    setCurrentPage(page);
    setSelectedCommitteeCategory(null);
  };

  const handleCommitteeSelection = (category) => {
    setSelectedCommitteeCategory(category);
  };

  const handleBackToCommittees = () => {
    setSelectedCommitteeCategory(null);
  };

  // SHOW SCROLL BUTTON EFFECT
  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > 300) {
        setFadeOut(false);
        setShowScroll(true);
      } else if (showScroll) {
        setFadeOut(true);
        setTimeout(() => setShowScroll(false), 500); // match CSS fade-out duration
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, [showScroll]);

  // SCROLL TO TOP WHEN PAGE CHANGES
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  // SCROLL TO TOP BUTTON FUNCTION
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="app">
      <Navbar onNavigate={handleNavigation} />

      {currentPage === "home" ? (
        <>
          <Hero />
          <AboutSection />
          <Timeline />
          <Partners />
        </>
      ) : currentPage === "about" ? (
        <AboutPage />
      ) : currentPage === "committee" ? (
        selectedCommitteeCategory ? (
          <CommitteeMemberDetails
            category={selectedCommitteeCategory}
            onBack={handleBackToCommittees}
          />
        ) : (
          <Committee onSelectCategory={handleCommitteeSelection} />
        )
      ) : currentPage === "call-for-papers" ? (
        <CallForPapers />
      ) : currentPage === "registration" ? (
        <Registration />
      ) : currentPage === "contact-us" ? (
        <ContactUs />
      ) : null}

      <Footer />

      {/* Always render button, toggle fade */}
      {(showScroll || fadeOut) && (
        <button
          className={`scroll-top-btn ${fadeOut ? "fade-out" : ""}`}
          onClick={scrollToTop}
        >
          ↑
        </button>
      )}
    </div>
  );
}

export default App;
